function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUsp2 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 320 160",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h320v160H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.718 158.051s-2.714-5.01-9.278-2.843l9.278 2.843Z",
    style: {
      fill: "#e6e6e6",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.881 157.929s-3.356-4.267 1.488-9.59l-1.488 9.59Z",
    style: {
      fill: "#e6e6e6",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3f3d56",
      fillRule: "nonzero"
    },
    d: "M76.44 157.735h167.345v1H76.44z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m203.432 111.684 3.624 14.09s.134 9.931.939 13.823c.805 3.892 3.49 13.286 3.49 13.286l3.22.537-.671-13.152s0-7.918-.671-9.662c-.671-1.745-2.013-19.593-2.013-19.593l-7.918.671Z",
    style: {
      fill: "#fbbebe",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m203.244 110.741 3.623 14.091s.134 9.931.94 13.823c.806 3.892 3.489 13.286 3.489 13.286l3.22.536-.67-13.151s0-7.918-.671-9.662c-.671-1.745-2.013-19.594-2.013-19.594l-7.918.671Z",
    style: {
      fillOpacity: 0.1,
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.478 52.623c-4.473 0-8.1 4.024-8.1 8.989v6.307h1.94l1.123-2.337-.28 2.337h12.468l1.02-2.124-.254 2.124h1.403v-4.952c0-5.713-4.172-10.344-9.32-10.344Z",
    style: {
      fill: "#585ddb",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.01 109.47s-1.61 6.844.537 7.515c2.147.67 1.61-7.516 1.61-7.516l-2.147.001Z",
    style: {
      fill: "#fbbebe",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m202.694 74.712-1.074 1.207.269 23.217-2.416 11.004 5.368.537 2.684-22.143-.805-11.273-4.026-2.549Z",
    style: {
      fill: "#d0cde1",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m202.645 74.712-1.073 1.207.268 23.217-2.415 11.004 5.368.537 2.684-22.143-.806-11.273-4.026-2.549Z",
    style: {
      fillOpacity: 0.1,
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 212.761,
    cy: 61.272,
    r: 5.766,
    style: {
      fill: "#fbbebe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.455 64.731s1.692 8.765.923 9.687c-.769.923 8.15-1.691 8.15-1.691s-2.922-5.997-1.384-9.38l-7.689 1.384Zm14.577 38.431s1.61 6.844-.537 7.515c-2.147.671-1.61-7.515-1.61-7.515h2.147Zm-12.414 6.911s-2.281 13.689-2.147 15.702c.134 2.013 0 2.281 0 2.281s-2.281 5.905-2.952 9.26c-.671 3.355-2.147 7.65-2.147 7.65s-1.745 3.891-.269 3.891 3.49-.537 3.49-.537a6.854 6.854 0 0 1 1.476-4.272c1.61-2.035 6.441-11.563 6.441-12.771 0-1.208.805-4.697.805-4.697l3.087-14.896-7.784-1.611Z",
    style: {
      fill: "#fbbebe",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.224 100.948s-2.281 11.54-.268 11.81c2.013.268 4.831-1.745 8.455.536 3.623 2.281 9.662 1.745 9.662 1.745s4.16-10.602.403-13.152c-3.757-2.55-18.252-.94-18.252-.94v.001Zm2.55 46.299a3.57 3.57 0 0 1 1.879-.269 2.452 2.452 0 0 0 1.745-.402c.51-.349-1.074 3.891-.94 5.368.134 1.477-.402 7.783-3.22 7.112-2.819-.67-3.624-2.684-2.55-6.173 1.073-3.49.805-7.515.805-7.515s1.958-2.023 2.321-1.75c.363.274-.04 3.629-.04 3.629Z",
    style: {
      fill: "#2f2e41",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.766 152.212s-1.342-2.952-2.953-.268c-1.611 2.684-1.744 3.355-1.744 3.355s-4.563 4.16-1.342 4.562c3.22.403 5.77-.134 5.77-.805 0-.67 1.61-.537 1.745-1.073.134-.537-.269-5.503-.269-5.503l-1.207-.268Z",
    style: {
      fill: "#2f2e41",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.785 69.21s-5.636 1.073-6.307.939a3.34 3.34 0 0 0-.458-.049 6.788 6.788 0 0 0-3.746.93c-1.868 1.085-4.653 3.017-4.653 4.89 0 2.818 3.623 7.649 3.623 7.649s-3.355 11.541-3.087 12.615c.269 1.073-2.013 4.697-.536 5.904 1.476 1.208 15.567 0 18.116 1.208 2.549 1.208 1.342-16.104 1.342-16.104s6.845-15.701 3.355-17.177a44.963 44.963 0 0 0-2.905-1.119 6.14 6.14 0 0 0-4.744.313v.001Z",
    style: {
      fill: "#d0cde1",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m222.019 70.149 3.08.509s1.348 1.37 1.348 2.04c0 .67-.268 29.659-.67 30.598-.403.94-4.832.537-4.832.537l.805-16.507.269-17.177Z",
    style: {
      fill: "#d0cde1",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.78 55.1a4.253 4.253 0 0 0-3.351-1.711h-.16c-3.065 0-5.55 2.774-5.55 6.196h1.027l.166-1.262.243 1.262h6.093l.51-1.068-.127 1.068h1.198c.56 2.778-.244 5.556-2.41 8.334h2.041l1.021-2.137-.255 2.137h3.892l.766-4.915c0-3.68-2.138-6.801-5.103-7.905l-.001.001Z",
    style: {
      fill: "#585ddb",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 216.9,
    cy: 52.583,
    r: 3.034,
    style: {
      fill: "#585ddb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.668 48.967h-.786V27.452c0-6.831-5.621-12.452-12.452-12.452h-45.582c-6.831 0-12.452 5.621-12.452 12.452v118.033c0 6.831 5.621 12.452 12.452 12.452h45.582c6.831 0 12.452-5.621 12.452-12.452V64.282h.786V48.967Z",
    style: {
      fill: "#061437",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.933 18.24h-5.95c.216.53.327 1.096.327 1.668 0 2.423-1.994 4.417-4.417 4.418h-26.115c-2.423-.001-4.417-1.995-4.417-4.418 0-.572.111-1.138.327-1.668h-5.558c-5.101 0-9.299 4.198-9.3 9.299v117.86c.001 5.101 4.199 9.298 9.3 9.298h45.802c5.101-.001 9.298-4.198 9.299-9.299V27.538c-.001-5.101-4.199-9.298-9.3-9.298h.002Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.942 97.19h-8.824v-2.124h8.824v2.124Zm-36.277 0h-3.104v-2.124h3.104v2.124Zm-6.209 0h-3.106v-2.124h3.105l.001 2.124Zm30.557 0h-21.08v-2.124h21.08v2.124Zm-13.236 13.727h-3.105v-2.125h3.105v2.125Zm-6.209 0h-3.105v-2.125h3.105v2.125Zm30.557 0h-21.08v-2.125h21.08v2.125Zm-24.511-8.987h-8.824v-2.125h8.824v2.125Zm-11.929 0h-8.824v-2.125h8.824v2.125Zm42.16 0h-3.105v-2.125h3.105v2.125Zm-6.21 0h-21.08v-2.125h21.08v2.125Zm-14.543 2.45h8.824v2.125h-8.824v-2.125Zm11.928 0h8.825v2.125h-8.825v-2.125Zm-42.16 0h3.106v2.125h-3.106v-2.125Zm6.21 0h21.08v2.125h-21.08v-2.125Z",
    style: {
      fill: "#ff4d3c",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 147.067,
    cy: 60.334,
    r: 16.861,
    style: {
      fill: "#ff4d3c"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 145.862,
    cy: 60.936,
    r: 5.42,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.027 61.26c-.337-.518-.167-1.224-.403-1.796-.372-.898-1.526-1.108-2.494-1.19a7.438 7.438 0 0 0-1.932.005 1.853 1.853 0 0 0-1.34.971c-.144.288-.108-.613-.016-1.768a5.599 5.599 0 0 1 4.325-5.008c1.18-.272 2.395-.472 3.597-.331 1.202.141 2.4.66 3.15 1.61.343.434.585.945.968 1.345.672.701 1.669.957 2.585 1.282 1.035.368 2.042.873 2.834 1.635.792.762 1.353 1.806 1.37 2.905.019 1.282-.796 2.605-2.11 2.858a1.48 1.48 0 0 0-.63.271c-1.255.973.176 1.991.166 3.087-.008.913-1.025 1.509-1.938 1.551a3.69 3.69 0 0 1-3.663-2.91c-.138-.75-.031-1.52.058-2.277.103-.867-1.764-2.907-.53-1.411.24.284.402.626.47.992.206 1.195-.882 1.597-1.567 2.26a2.845 2.845 0 0 0-.688 2.924 3.286 3.286 0 0 1-.596-4.137c.221-.339.506-.633.715-.98.327-.54.417-1.713-.498-1.681-.653.023-1.331.567-1.833-.206v-.001Z",
    style: {
      fill: "#585ddb",
      fillRule: "nonzero"
    }
  }));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUsp2);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/usp2.ab33461d3a16a631f5e8373c8efc1de8.svg";